import get from 'lodash/get';
import find from 'lodash/find';

import {getResource, getResourceWithoutId} from '~/misc/resourceId';

const loadFromState = (fullState, loadIdentity) => {
  const resource = getResource(fullState, loadIdentity);
  if (resource) {
    return resource.item;
  }

  const parentIdentity = loadIdentity.parentIdentity;

  const parentResource = getResource(fullState, parentIdentity);
  if (parentResource) {
    const load = get(parentResource, ['item', 'index', loadIdentity.props.id]);
    return load;
  }

  const load = get(fullState, [parentIdentity.name, 'itemsIndex', loadIdentity.props.id]);
  if (load) {
    return load;
  }

  const alert = find(get(
    fullState,
    ['alert', 'LoadsList', 'shipments']),
    {id: loadIdentity.props.id});
  if (alert) {
    return alert;
  }
  const loadList = find(get(
    fullState,
    ['myLoads', loadIdentity.name, 'results', 'shipments']),
    {id: loadIdentity.props.id}
  );
  if (loadList) {
    return loadList;
  }

  return get(getResourceWithoutId(fullState, 'load', {id: loadIdentity.props.id}), 'item');
};

export const getLoad = (fullState, loadId) => {
  const load = get(fullState, ['loadsSearch', 'itemsIndex', loadId])
    || get(fullState, ['similarLoads', 'itemsIndex', loadId]);

  if (load) {
    return load;
  }

  return get(getResourceWithoutId(fullState, 'load', {id: loadId}), 'item');
};

export default loadFromState;



// WEBPACK FOOTER //
// ./src/misc/loadFromState.js